import dayjs, {Dayjs} from 'dayjs';
import {getStrings} from '../lang';
import strings from '../../lang/locale.strings.yaml';

const S = getStrings<LocaleStrings>(strings);
export default function (option: any, dayjsClass: Function, dayjsFactory: Function): void {
    dayjsClass.prototype.getDuration = function (date: Dayjs) {
        const totalMs: number = Math.abs(date ? this.diff(date) : this.valueOf());
        const totalMinutes: number = Math.floor(totalMs / 60000);
        const days: number = Math.floor(totalMinutes / 1440);
        const hours: number = Math.floor((totalMinutes % 1440) / 60);
        const minutes: number = totalMinutes % 60;
        let duration: string = '';
        if (days > 0) {
            duration += `${days} ${S.daysShort} `;
        }
        if (hours > 0) {
            duration += `${hours} ${S.hoursShort} `;
        }
        if (minutes > 0) {
            duration += `${minutes} ${S.minutesShort}`;
        }
        return duration.length ? duration.trim() : `0 ${S.minutesShort}`;
    };

    dayjsClass.prototype.getHours = function (date?: Dayjs): number {
        const totalMs: number = Math.abs(date ? this.diff(date) : this.valueOf());
        const totalMinutes: number = Math.floor(totalMs / 60000);
        return Math.floor(totalMinutes / 60);
    };
    dayjsClass.prototype.getDurationShort = function (date?: Dayjs): string {
        const totalMs: number = Math.abs(date ? this.diff(date) : this.valueOf());
        const totalMinutes: number = Math.floor(totalMs / 60000);
        const hours: number = Math.floor(totalMinutes / 60);
        const minutes: number = totalMinutes % 60;
        return `${hours}${S.hoursShort} ${minutes}${S.minutesShort}`;
    };
    dayjsClass.prototype.getDurationTime = function (date?: Dayjs): string {
        const totalMs: number = Math.abs(date ? this.diff(date) : this.valueOf());
        const totalMinutes: number = Math.floor(totalMs / 60000);
        const days: number = Math.floor(totalMinutes / 1440);
        const hours: number = Math.floor((totalMinutes % 1440) / 60);
        const minutes: number = totalMinutes % 60;
        let duration: string = '';
        if (days > 0) {
            duration += `${days}:`;
        }
        duration += `${hours}:${minutes}`;
        return duration;
    };
    dayjsClass.prototype.getDateStr = function (): string {
        return this.format('L');
    };
    dayjsClass.prototype.getTimeStr = function (): string {
        return this.format('HH:mm:ss');
    };
    dayjsClass.prototype.getDayjsStr = function (): string {
        return this.format('L HH:mm');
    };
    dayjsClass.prototype.getShortTimeStr = function (): string {
        return this.format('HH:mm');
    };
    dayjsClass.prototype.getTimeArray = function (): string[] {
        return [this.format('HH'), this.format('mm')];
    };
    dayjsClass.prototype.clearTime = function (): Dayjs {
        return this.startOf('day');
    };
    dayjsClass.prototype.setTimeStr = function (time: string): Dayjs {
        let t: Dayjs = dayjs.utc(time, 'HH:mm:ss');
        this.set('hour', t.hour()).set('minute', t.minute()).set('second', t.second());
        return this;
    };
    dayjsClass.prototype.getSign = function (): number {
        return this.valueOf() > 0 ? 1 : -1;
    };
    dayjsClass.prototype.getDateTimeStr = function (): string {
        return this.format('L HH:mm');
    };
    dayjsClass.prototype.getShortTimeStr = function (): string {
        return this.format('HH:mm');
    };
    dayjsClass.prototype.getDayOfWeek = function (): string {
        const weekDayNumber = this.day();
        // todo if sunday is not first?
        return ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][weekDayNumber];
    };
    dayjsClass.prototype.daysCount = function (): number {
        return Math.ceil(this.startOf('day') / 86400000);
    };
}

declare module 'dayjs' {
    interface Dayjs {
        getDuration(date?: Dayjs): string;
        getHours(date?: Dayjs): number;
        getDurationShort(date?: Dayjs): string;
        getDurationTime(date?: Dayjs): string;
        getDateStr(): string;
        getTimeStr(): string;
        getDayjsStr(): string;
        getShortTimeStr(): string;
        getTimeArray(): string[];
        clearTime(): Dayjs;
        setTimeStr(time: string): Dayjs;
        getDateTimeStr(): string;
        getShortTimeStr(): string;
        getSign(): number;
        getDayOfWeek(): string;
        daysCount(): number;
    }
}
